import React from 'react';
import { useIntl } from 'react-intl';
import { Card, CardBody, CardHeader } from 'reactstrap';
import styled from 'styled-components';

import Breadcrumbs from 'src/enosikit/components/Breadcrumbs';
import Heading from 'src/enosikit/components/Heading';

const Shimmer = styled.span.attrs({
  className: 'placeholder placeholder-glow bg-darken',
})`
  display: inline-block;
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '1rem'};
  border-radius: 0.25rem;
`;

/**
 * Skeleton chrome rendered behind the error modal by `PlaceholderErrorBoundary`
 * after the TradeRuleSetCommunity route query fails.
 * @returns {React.ReactNode} Placeholder content.
 */
function TradeRuleSetCommunityPlaceholder() {
  const intl = useIntl();
  const breadcrumbs = [
    {
      name: intl.formatMessage({
        id: 'trade_rule.trade_rule_set_community.placeholder.breadcrumbs.properties.label',
        defaultMessage: 'Properties',
      }),
      path: '/properties',
    },
    {
      name: intl.formatMessage({
        id: 'trade_rule.trade_rule_set_community.placeholder.breadcrumbs.trade_rules.label',
        defaultMessage: 'Trade Rules',
      }),
      path: '/trade-rules',
    },
    {
      name: intl.formatMessage({
        id: 'trade_rule.trade_rule_set_community.placeholder.breadcrumbs.set_community_trade_rules.label',
        defaultMessage: 'Set community trade rules',
      }),
    },
  ];

  return (
    <div aria-hidden="true">
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <Heading
        title={intl.formatMessage({
          id: 'trade_rule.trade_rule_set_community.placeholder.heading.title',
          defaultMessage: 'Set community trade rules',
        })}
        subtitle={<Shimmer width="12rem" />}
      />
      <Card>
        <CardHeader>
          <Shimmer width="14rem" height="1.5rem" />
        </CardHeader>
        <CardBody>
          <Shimmer height="2.5rem" />
          <div className="mt-3">
            <Shimmer height="2.5rem" />
          </div>
          <div className="mt-3">
            <Shimmer height="2.5rem" />
          </div>
        </CardBody>
      </Card>
    </div>
  );
}

export default TradeRuleSetCommunityPlaceholder;
